"use client";

import { PaymentIcons } from "@repo/components";
import { usePayByApplePayExist } from "@repo/lib/hooks/checkout";
import { Radio } from "@repo/ui";
import cx from "classnames";
import { useCallback } from "react";
const multiLinePaymentCodes = new Set(["TAP", "PAYFORT"]);
const CheckoutPaymentOptions = ({
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  paymentMethods
}) => {
  const {
    isApplePayAvailable
  } = usePayByApplePayExist();
  const handleSelectPaymentMethod = useCallback(code => {
    setSelectedPaymentMethod(code);
  }, [setSelectedPaymentMethod]);
  const filteredPaymentMethods = paymentMethods?.filter(option => {
    if (option.code === "APPLEPAY") {
      return option.active && isApplePayAvailable;
    }
    return true;
  });
  return <>
      {filteredPaymentMethods?.map(option => {
      const isEnabled = option?.active;
      if (option.code === "APPLEPAY" && !isApplePayAvailable) {
        return null;
      }
      const requiresMobileMultiLineLayout = multiLinePaymentCodes.has(option.code);
      return <div key={option?.code} className="group">
            {isEnabled && <div key={option.code} className={cx("border-supportiveDarkGray mb-4 flex items-center border px-4 group-last:mb-0", {
          "flex-wrap": requiresMobileMultiLineLayout
        })}>
                <Radio onChange={() => handleSelectPaymentMethod(option.code)} id={`checkout_payment_options_${option.code}`} name="checkout_payment_options" checked={selectedPaymentMethod === option.code} value={option.code}>
                  <span className={cx("py-3 ps-3 text-sm", {
              "block md:flex md:w-full": requiresMobileMultiLineLayout,
              "flex w-full items-center": !requiresMobileMultiLineLayout
            })}>
                    {option.title}
                    <PaymentIcons option={option.code} requiresMobileMultiLineLayout={requiresMobileMultiLineLayout} />
                  </span>
                </Radio>
              </div>}
          </div>;
    })}
    </>;
};
export default CheckoutPaymentOptions;